// src/App.js
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ReactGA from 'react-ga4';
import MainFrame from './Component/Main/MainFrame';
import AdviseFrame from './Component/AdVise/AdViseFrame'; // 새로 만들 컴포넌트
import './App.css';
import BeforeOBT from './BeforeOBT';
import StoreRedirect from './StoreRedirect';
import KakaoCallbackPage from './KakaoCallbackPage';
import AdLanding from './Component/AdLanding/AdLanding';

function App() {
  useEffect(() => {
    ReactGA.initialize(process.env.REACT_APP_GA_KEY);
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });

    const params = new URLSearchParams(window.location.search);
    const utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

    utmKeys.forEach(key => {
      const value = params.get(key);
      if (value) {
        localStorage.setItem(key, value);
      }
    });
  }, []);

  return (
    <div className="App">
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <Router>
        <Routes>
          <Route path="/auth/kakao/callback" element={<KakaoCallbackPage />} />
          <Route path="/ad/*" element={<AdLanding />} />
          <Route path="/ig/*" element={<StoreRedirect />} />
          <Route path="/fb/*" element={<StoreRedirect />} />
          <Route path="/advise/*" element={<AdviseFrame />} />
          <Route path="/*" element={<MainFrame />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;